module.exports = __webpack_public_path__ + "static/media/05.6420d6d7.jpg";